export default "__VITE_ASSET__CgPMXCEY__"